export class Adapter {
  adapt(item) {
    return item;
  }
}
